<template>
  <v-app id="app">
    <navigation :user_name="userToken.name" :logged="logged" @logOut="logOut"/>
    <router-view :routeProps="routeProps"
                 @checkToken="checkUserToken"
                 :user-token="userToken"
                 @logOut="logOut"
                 @login="login"/>
  </v-app>
</template>

<script>
import Api from "@/services/api";
import Navigation from "@/components/Navigation";

export default {
  name: "app",
  components: {
    Navigation
  },
  data: () => ({
    userToken: '',
    logged: false
  }),

  computed: {
    routeProps() {
      switch (this.$route.name) {
        case "User":
          return this.userToken
        default:
          return ""
      }
    }
  },

  methods: {
    loadToken() {
      let token = this.$cookies.get('user_token');
      if (token !== null) {
        return token
      }
    },

    logOut() {
      this.$cookies.remove('user_token')
      this.logged = false;
      this.$router.push('/login')
    },
    login() {
      this.logged = true;
      this.$router.push('/')
      this.loadUserToken();
    },

    async checkUserToken() {
      let token = this.loadToken()
      let userTokenInfo = await this.api.getToken(token);
      if (userTokenInfo === "") {
        this.$cookies.remove("user_token")
        this.logged = false;
        //todo toast notification: warning expired session
        await this.$router.push('/login')
      }
    },

    async loadUserToken() {
      let token = this.loadToken()
      let userTokenInfo = await this.api.getToken(token);
      if (userTokenInfo === "") {
        this.$cookies.remove("user_token")
      } else {
        this.userToken = userTokenInfo
        this.logged = true;
      }
    }
  },

  async created() {
    this.api = new Api()
    await this.loadUserToken()
  }
};
</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/meyer-reset/2.0/reset.css";

</style>
